import { useState } from "react";

const CONTACT_FORM_ADDR = "https://readdy.ai/api/form/dagodeptto0ceqqni1qg";

const TYPE_OPTIONS = ["人物档案补充", "素材线索投稿", "纠错与反馈", "合作与其它"];

const INIT = { name: "", email: "", type: "人物档案补充", topic: "", message: "" };

export default function Contact() {
  const [form, setForm] = useState(INIT);
  const [formError, setFormError] = useState("");
  const [status, setStatus] = useState<"idle" | "success" | "error">("idle");

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setFormError("");
    const formEl = e.currentTarget;
    const data = new FormData(formEl);
    const honey = String(data.get("company_alt") || "").trim();
    if (honey) {
      setStatus("success");
      formEl.reset();
      setForm(INIT);
      return;
    }
    data.delete("company_alt");
    if (!String(data.get("message") || "").trim()) {
      setFormError("请先填写你的爆料或反馈内容。");
      setStatus("error");
      return;
    }
    try {
      const res = await fetch(CONTACT_FORM_ADDR, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: new URLSearchParams(data as unknown as Record<string, string>).toString(),
      });
      const responseText = await res.text();
      let parsed: { code?: string; meta?: { message?: string } } | null = null;
      try {
        parsed = JSON.parse(responseText);
      } catch {
        parsed = null;
      }
      const code = parsed?.code || "";
      const msg = parsed?.meta?.message || responseText;
      const isSpam = msg.toLowerCase().includes("spam");
      if (res.ok && (code === "OK" || code === "ok") && !isSpam) {
        setStatus("success");
        formEl.reset();
        setForm(INIT);
      } else {
        setFormError(isSpam ? "提交未成功，请稍后再试。" : (msg || "提交失败，请稍后再试。"));
        setStatus("error");
      }
    } catch {
      setFormError("网络异常，请稍后再试。");
      setStatus("error");
    }
  };

  return (
    <section id="contact" className="scroll-mt-20 bg-background-100 py-14 md:py-20 border-t border-background-200 overflow-hidden">
      <div className="mx-auto max-w-[1320px] px-4 md:px-6">
        <div className="grid lg:grid-cols-2 gap-10 lg:gap-14 items-center">
          <div>
            <p className="flex items-center gap-2 text-xs font-medium uppercase tracking-widest text-primary-600">
              <span className="h-px w-8 bg-primary-400"></span> 投稿爆料
            </p>
            <h2 className="mt-3 font-heading font-black text-2xl md:text-4xl text-foreground-950">
              有线索？来聊聊你的瓜
            </h2>
            <p className="mt-4 text-sm md:text-base leading-relaxed text-foreground-700">
              无论是补充某位海外博主的人物档案、提供新的翻车线索，还是对既有内容的纠错反馈，都欢迎通过下方表单联系海外吃瓜团队。
            </p>
            <p className="mt-3 text-sm text-foreground-600">
              我们会在核对素材后决定是否收录，并尽量在 48 小时内回复你。
            </p>

            <div className="mt-7 flex flex-wrap gap-2.5">
              {["📮 爆料邮箱：gossip@readdy.site", "🕑 响应时间：48 小时内", "🛡 匿名投稿：支持"].map(
                (t) => (
                  <span
                    key={t}
                    className="inline-flex items-center rounded-full bg-background-50 border border-background-300 px-3.5 py-1.5 text-sm text-foreground-700"
                  >
                    {t}
                  </span>
                )
              )}
            </div>
          </div>

          <div className="rounded-3xl bg-background-50 border border-background-200 p-6 md:p-8">
            {status === "success" ? (
              <div className="flex flex-col items-center justify-center text-center py-10">
                <span className="flex items-center justify-center w-16 h-16 rounded-full bg-secondary-100 text-secondary-600">
                  <i className="ri-check-double-line text-3xl"></i>
                </span>
                <h3 className="mt-4 font-heading font-bold text-xl text-foreground-950">爆料已收到！</h3>
                <p className="mt-2 text-sm text-foreground-600 max-w-sm">
                  感谢你的线索，我们会在核对后跟进。欢迎继续逛逛站内的逐帧现场与人物档案。
                </p>
                <button
                  type="button"
                  onClick={() => setStatus("idle")}
                  className="mt-5 inline-flex items-center gap-2 rounded-full bg-background-100 border border-background-300 px-5 py-2.5 text-sm font-medium text-foreground-800 hover:border-primary-300 transition-colors whitespace-nowrap cursor-pointer"
                >
                  再发一条
                </button>
              </div>
            ) : (
              <form
                data-readdy-form="gossip-contact"
                onSubmit={handleSubmit}
                className="space-y-4"
                noValidate
              >
                <div className="grid sm:grid-cols-2 gap-4">
                  <div>
                    <label htmlFor="name" className="block text-sm font-medium text-foreground-800 mb-1.5">
                      你的称呼
                    </label>
                    <input
                      id="name"
                      name="name"
                      type="text"
                      value={form.name}
                      onChange={handleChange}
                      placeholder="例如：吃瓜路人甲"
                      className="w-full rounded-xl border border-background-300 bg-background-50 px-4 py-2.5 text-sm text-foreground-950 placeholder:text-foreground-400 focus:outline-none focus:ring-2 focus:ring-primary-400 focus:border-primary-300"
                    />
                  </div>
                  <div>
                    <label htmlFor="email" className="block text-sm font-medium text-foreground-800 mb-1.5">
                      联系邮箱
                    </label>
                    <input
                      id="email"
                      name="email"
                      type="email"
                      value={form.email}
                      onChange={handleChange}
                      placeholder="you@example.com"
                      className="w-full rounded-xl border border-background-300 bg-background-50 px-4 py-2.5 text-sm text-foreground-950 placeholder:text-foreground-400 focus:outline-none focus:ring-2 focus:ring-primary-400 focus:border-primary-300"
                    />
                  </div>
                </div>

                <div>
                  <label htmlFor="type" className="block text-sm font-medium text-foreground-800 mb-1.5">
                    投稿类型
                  </label>
                  <select
                    id="type"
                    name="type"
                    value={form.type}
                    onChange={handleChange}
                    className="w-full rounded-xl border border-background-300 bg-background-50 px-4 py-2.5 text-sm text-foreground-950 focus:outline-none focus:ring-2 focus:ring-primary-400 focus:border-primary-300"
                  >
                    {TYPE_OPTIONS.map((t) => (
                      <option key={t} value={t}>{t}</option>
                    ))}
                  </select>
                </div>

                <div>
                  <label htmlFor="topic" className="block text-sm font-medium text-foreground-800 mb-1.5">
                    相关人物 / 事件名称 <span className="text-foreground-400 font-normal">（选填）</span>
                  </label>
                  <input
                    id="topic"
                    name="topic"
                    type="text"
                    value={form.topic}
                    onChange={handleChange}
                    placeholder="例如：某海外美妆博主"
                    className="w-full rounded-xl border border-background-300 bg-background-50 px-4 py-2.5 text-sm text-foreground-950 placeholder:text-foreground-400 focus:outline-none focus:ring-2 focus:ring-primary-400 focus:border-primary-300"
                  />
                </div>

                <div>
                  <label htmlFor="message" className="block text-sm font-medium text-foreground-800 mb-1.5">
                    爆料 / 反馈内容
                  </label>
                  <textarea
                    id="message"
                    name="message"
                    value={form.message}
                    onChange={handleChange}
                    maxLength={500}
                    rows={5}
                    placeholder="请尽量描述时间、人物与关键素材，方便我们核对……"
                    className="w-full resize-none rounded-xl border border-background-300 bg-background-50 px-4 py-2.5 text-sm text-foreground-950 placeholder:text-foreground-400 focus:outline-none focus:ring-2 focus:ring-primary-400 focus:border-primary-300"
                  ></textarea>
                  <div className="mt-1 text-right text-xs text-foreground-400">{form.message.length}/500</div>
                </div>

                {/* honeypot anti-spam */}
                <div className="gossip-hp">
                  <input
                    type="text"
                    name="company_alt"
                    tabIndex={-1}
                    autoComplete="off"
                    aria-hidden="true"
                    readOnly
                    value=""
                    placeholder="公司"
                  />
                </div>

                {formError && (
                  <p className="flex items-center gap-2 rounded-xl bg-primary-50 border border-primary-200 px-4 py-3 text-sm text-primary-700" role="alert">
                    <i className="ri-error-warning-line"></i>
                    {formError}
                  </p>
                )}

                <button
                  type="submit"
                  className="w-full inline-flex items-center justify-center gap-2 rounded-xl bg-primary-500 px-4 py-3 text-sm font-medium text-background-50 hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-send-plane-fill"></i> 提交爆料
                </button>
                <p className="text-center text-xs text-foreground-500">
                  提交即表示你同意我们对素材进行基础核对与按需标注
                </p>
              </form>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}